import { render } from "./ZoneWizard.vue?vue&type=template&id=a2dec990&scoped=true"
import script from "./ZoneWizard.vue?vue&type=script&lang=js"
export * from "./ZoneWizard.vue?vue&type=script&lang=js"

import "./ZoneWizard.vue?vue&type=style&index=0&id=a2dec990&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a2dec990"]])

export default __exports__